import React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { ListGrid, ReportGrid } from '../../styles/styles';

interface Props {
  list: React.ReactNode;
  report?: React.ReactNode;
  hideReport?: boolean;
  size?: string;
}

const ListLayout: React.FC<Props> = ({
  list,
  report,
  hideReport = true,
  size = 'sm',
}) => {
  return (
    <ListGrid container spacing={2}>
      {hideReport ? null : (
        <Hidden smUp>
          <ReportGrid item xs={12}>
            {report}
          </ReportGrid>
        </Hidden>
      )}

      <Grid item xs={12} sm={size === 'sm' ? 7 : 10}>
        {list}
      </Grid>
    </ListGrid>
  );
};

export default ListLayout;
